module.exports = __webpack_public_path__ + "components/flag/static/square/gd-5a9b5d94a8fe1ec81a88bfdaed835aec.svg";